import React from 'react'

const GridImage = ({ imageClassName, alt, imgSrcs }) => {
  return (
    <img
      sizes={imgSrcs.sizes}
      srcSet={imgSrcs.srcSet}
      src={imgSrcs.defaultImage.url}
      alt={alt}
      className={imageClassName}
    />
  )
}

export default GridImage
